import React, { useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiButton from "Components/MuiButton/MuiButton";
import { read } from "Helpers/LocalStorage";
import UserProfileService from "Services/http/endpoints/userProfile/UserProfileService";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import VerifyModal from "./VerifyModal";
import { useTranslation } from "react-i18next";

export default function ProfileEmail({ data }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [openDialog, setOpenDialog] = useState(false);

  const [controls, setControls] = useSetState({
    email: {
      type: "text",
      value: "",
      validation: null,
    },
  });

  const handleDialog = (isChange) => {
    setOpenDialog(!openDialog);
    if (openDialog && !isChange) {
      if (data) {
        setControls({ email: { value: data.Email } });
      }
      setFormValid({});
    } else if (openDialog && isChange) {
      setFormValid({});
    }
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onSubmit = async () => {
    const { email } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const dataPost = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Type: 1,
          Account: email.value,
        };
        const response = await UserProfileService.postProfileContact(dataPost);
        let err = StatusHandler(response);
        if (!err.isFail) {
          setOpenDialog(true);
        } else {
          if (data) {
            setControls({ email: { value: data.Email } });
          }
          setFormValid({});
        }
        setLoading(false);
      } catch (e) {
        if (data) {
          setControls({ email: { value: data.Email } });
        }
        setFormValid({});
        setLoading(false);
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "warning",
      });
    }
  };

  const resendCode = async () => {
    try {
      setLoading(true);
      const dataPost = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Type: 1,
        Account: controls.email.value,
      };
      const response = await UserProfileService.postProfileContact(dataPost);
      let err = StatusHandler(response);
      if (!err.isFail) {
      } else {
        if (data) {
          setControls({ email: { value: data.Email } });
        }
        setFormValid({});
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      setControls({ email: { value: data.Email } });
    }
  }, [data]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2}>
        <Grid item sm={4} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="email"
            validation={controls.email.validation}
            label={<Translator id="email" />}
            value={controls.email.value}
            disabled={controls.email.disabled}
            type="text"
          />
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          className="d-flex flex-row justify-content-start align-items-center"
        >
          <MuiButton
            loading={loading}
            color="primary"
            title={<Translator id="zakhire" />}
            onClick={onSubmit}
            disabled={R.isEmpty(formValid)}
            fullwidthOnSm
          />
        </Grid>
      </Grid>
      <VerifyModal
        type={1}
        open={openDialog}
        handleDialog={handleDialog}
        account={controls.email.value}
        resendCode={resendCode}
      />
    </>
  );
}
